<template>
  <survey-popup :linkUrl="linkUrl" v-if="isDisplay" @close="close">
    <template #title>{{ title }}</template>
    <template #text>{{ text }}</template>
    <template #linkText>{{ linkText }}</template>
  </survey-popup>
</template>

<script>
import SurveyPopup from './common/SurveyPopup';
import moment from 'moment';

export default {
  components: { SurveyPopup },
  props: {
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    linkUrl: {
      type: String,
      required: true
    },
    linkText: {
      type: String,
      required: true
    },
    displayTargetCode: {
      type: Number,
      required: true
    },
    validPath: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      isDisplay: false
    };
  },
  created() {
    // TODO: APIを実装した際にpatientIDを一緒に取ってくる実装に変える
    const patientId = document
      .getElementById('enquete-app')
      ?.getAttribute('data-patient-id');

    // TODO: 以下のようなデータ構造をAPIから取得する想定で作成
    // displayTargetCode: 1=ログイン, 2=非ログイン
    // validPath: 配列でPathを指定して、完全一致or前方一致 で評価
    //    REVIEW: 正規表現を直接指定するでも良いかも？

    const LOGGED_IN = 1;
    const NOT_LOGGED_IN = 2;

    const login = document
      .getElementById('enquete-app')
      ?.getAttribute('data-login');
    if (this.displayTargetCode === LOGGED_IN && login !== 'true') return;
    if (this.displayTargetCode === NOT_LOGGED_IN && login === 'true') return;

    const path = location.pathname;
    if (!this.validPath.includes(path)) {
      let validFlag = false;
      for (let i = 0, len = this.validPath.length; i < len; ++i) {
        if (this.validPath[i] == '/') continue;
        let regex = RegExp('^' + this.validPath[i] + '*');
        if (regex.test(path)) {
          validFlag = true;
        }
      }
      if (!validFlag) return;
    }

    const now = moment(moment().format('YYYYMMDD'));
    const start = moment(this.startDate);
    const end = moment(this.endDate);
    if (!now.isBetween(start, end, null, '[]')) return;

    if (Object.keys(this).length === 0) return;

    this.id = 'enquete-' + this.startDate;
    this.title = this.title;
    this.text = this.text;
    this.linkUrl = this.linkUrl;
    this.linkText = this.linkText;
    this.isDisplay = this.display();
  },
  methods: {
    display() {
      // TODO: COVID-19向けの無料相談開放中は常に表示するが、普段はcookieを使って表示状態を記憶する。COVID-19対応が収束したら戻すためコメントアウトで残しておく
      /* if (!this.id) return false;
      const enqueteCookie = ((document.cookie + ';').match(
        this.id + '=([0-1]*)'
      ) || [])[1];
      return enqueteCookie == '1' ? false : true; */
      return true;
    },
    close() {
      // document.cookie = this.id + '=1; path=/;';
      return (this.isDisplay = false);
    }
  }
};
</script>
